import { Component } from '@angular/core';
import { UserService } from './services/user.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent {

  constructor(
    private userService: UserService,
    private translateService: TranslateService
  ) {
    this.userService.getUserInfo();
    // 获取当前浏览器的语言
    const browserLang = this.getBrowserLanguage();
    const supportedLanguages = ['zh', 'en', 'ja'];
    const browserLangToUse = supportedLanguages.includes(browserLang) ? browserLang : 'en';
    const langToUse = localStorage.getItem('crowdtestQuestionLang') || browserLangToUse;
    console.log('langToUse: ', langToUse);
    this.translateService.use(langToUse);
  }

  getBrowserLanguage(): string {
    const nav = navigator || window.navigator;
    const browserLanguage =
      nav.language ||
      (nav as any).userLanguage ||
      (nav as any).browserLanguage ||
      (nav as any).systemLanguage ||
      'en';
    console.log('browserLanguage', browserLanguage)
    return browserLanguage.split('-')[0];
  }
}
